import React from 'react';
import { VimeoVideo } from '@components/VimeoVideo';
import { VideoWrapper } from './VideoWithStaticImages.styles';
import { VideoWithStaticImagesContent } from './VideoWithStaticImagesContent';

export interface VideoWithStaticImagesDesktopProps {
  readonly title: string;
  readonly video: string;
  readonly videoPoster: string;
  readonly backgroundVideo: string;
}

export const VideoWithStaticImagesDesktop: React.FC<VideoWithStaticImagesDesktopProps> = ({
  title,
  video,
  videoPoster,
  backgroundVideo,
}) => {
  return (
    <VideoWrapper>
      <VimeoVideo
        posterUrl={videoPoster}
        embedUrl={backgroundVideo}
        title="RZ Announcement"
        autoPlay
        background
        muted
        controls={false}
        loop
        autoPause={false}
        cover
      />
      <VideoWithStaticImagesContent title={title} video={video} videoPoster={videoPoster} />
    </VideoWrapper>
  );
};
